import styled from 'styled-components';

export const HeaderWrapper = styled.div`
  padding: 8px 0 0 25px;
`;

export const TableWrapper = styled.div`
  padding: 15px 20px 25px 20px;
`;
